<ng-container *transloco="let t; read 'permit.list'">

    <a *ngIf="item" class="item" [routerLink]="routerLink" routerLinkActive="router-link-active">
        <div *ngIf="item.companyName" class="premium-identifier"></div>

        <div class="content">
            <div class="item__header" [class.item__header--base]="!item.companyName">
                <div class="item__header__top">
                    <div class="item__header__top__row">
                        <div *ngIf="item.companyName" class="item__header__top__premium">
                            <img class="item__header__top__premium--icon" src="assets/images/icons/premium-icon-permit.svg">
                        </div>
                        <div class="item__header__top__status" [class]="'item__header__top__status--' + item.publicStatus"></div>
                        <div *ngIf="showFlammableIcon" class="item__header__top__flammable" [class.item__header__top__flammable--not]="!item.isFlammableHotWork"></div>
                        <div *ngIf="showFlammableAtexExplosionIcon" class="item__header__top__explosion"></div>
                        <div *ngIf="showFlammableAtexWindWarningIcon" class="item__header__top__wind-warning"></div>
                        <div *ngIf="item.isDemo" class="item__header__top__demo"></div>
                    </div>
                    <div class="item__header__top__row">
                        <div *ngIf="showFlammableAtexBadge" class="item__header__top__flammableAtexPermit" [innerHTML]="t('flammableAtexBadge')"></div>
                        <div class="item__header__top__id" [innerHTML]="t('id', { id: item.id })"></div>
                        <div *ngIf="item.roles?.length === 0 && !item.isIssuer" class="item__header__top__owner" [innerHTML]="t('issuerInitials', {name: getInitials(item.issuerName) })"></div>
                    </div>
                </div>
                <div class="item__header__center">
                    <div *ngIf="item.companyName" class="item__header__center__company" [innerHTML]="item.companyName"></div>
                    <div class="item__header__center__workplace" [class.item__header__center__workplace--is-demo]="item.isDemo" [innerHTML]="fullPermitName(item)"></div>
                    <div *ngIf="item.workplaceAdditionalInfo" class="item__header__center__additional-info" [innerHTML]="item.workplaceAdditionalInfo"></div>
                    <div *ngIf="isPlannedFlammableAtex" class="item__header__center__created-on" [innerHTML]="t('createdOn', { createdOn: item.createdOn | haDate:'dateTimeStandard' })"></div>
                </div>
            </div>
            <div class="item__content" [class.item__content--is-flammable]="!isNotFlammableAndCompleted" [class.item__content--is-demo]="isDemoAndCompleted">
                <ng-container *ngIf="!isPlannedFlammableAtex">
                <div *ngIf="item.endDate || item.uniqueParticipantCount > 1">
                    <div *ngIf="item.endDate" class="item__content__time">
                        <div [innerHTML]="t((item.publicStatus === PermitPublicStatus.ongoing ? 'validTo' : 'expired'), { endDate: item.endDate | haDate:'dateTimeStandard' })"></div>
                        <div *ngIf="item.publicStatus === PermitPublicStatus.ongoing" class="item__content__time__post" [innerHTML]="t('validPostMonitorTime')"></div>
                    </div>
                </div>
                <ng-container>
                    <div class="item__content__emergency">
                        <div class="item__content__emergency__number">
                            <div class="icon"></div>
                            <div>{{ item.emergencyNumber }}</div>
                        </div>
                        <div *ngIf="item.emergencyLocation" class="item__content__emergency__location">
                            <div class="icon"></div>
                            <div>{{ item.emergencyLocation }}</div>
                        </div>
                        <div *ngIf="item.hasDisabledFireAlarm === true" class="item__content__emergency__fire-alarm">
                            <div class="icon"></div>
                            <div>{{ item.disabledFireAlarm }}</div>
                        </div>
                    </div>

                    <div class="item__divider" [class.item__click]="routerLink">
                        <hr class="item__divider__line">
                    </div>

                    <div class="item__content__holder">
                        <div class="item__content__info">
                            <div class="item__content__info__section">
                                <div class="item__content__info__section__title" [innerHTML]="t('workMethods')"></div>
                                <div class="item__content__info__section__value" [innerHTML]="item.workMethods"></div>
                            </div>
                            <div *ngIf="item.uniqueParticipantCount > 1" class="item__content__info__section">
                                <div class="item__content__info__section__title" [innerHTML]="t('participantCount')"></div>
                                <div class="item__content__info__section__value" [innerHTML]="item.uniqueParticipantCount"></div>
                            </div>
                        </div>
                        <div class="item__content__info">
                            <div *ngIf="item.roles.length > 0 || item.isIssuer" class="item__content__info__section">
                                <div class="item__content__info__section__title" [innerHTML]="item.roles?.length > 1 ? t('myRoles') : t('myRole')"></div>
                                <div class="item__content__info__section__value" [innerHTML]="roles"></div>
                            </div>
                            <div *ngIf="item.roles.length === 0 && !item.isIssuer" class="item__content__info__section">
                                <div class="item__content__info__section__title" [innerHTML]="t('issuerTitle')"></div>
                                <div class="item__content__info__section__value" [innerHTML]="item.issuerName"></div>
                            </div>
                            <div class="item__content__info__section" *ngIf="item.isFlammableHotWork">
                                <div class="item__content__info__section__title" [innerHTML]="t('postWorkMonitoringTitle')"></div>
                                <div class="item__content__info__section__value" [innerHTML]="item.postWorkMonitoringTime"></div>
                            </div>
                        </div>
                        <div>
                            <div class="item__content__info__section">
                                <div class="item__header__right__remove" *ngIf="item.publicStatus === PermitPublicStatus.planned && canRemovePlannedPermit" (click)="remove($event)"></div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                </ng-container>

                <ng-container *ngIf="isPlannedFlammableAtex">
                     <div class="item__divider" [class.item__click]="routerLink">
                        <hr class="item__divider__line">
                    </div>
                    <div class="item__content__holder">
                        <div class="item__content__info">
                            <div class="item__content__info__section">
                                <div class="item__content__info__section__title" [innerHTML]="t('standaloneInfoTitle')"></div>
                                <div class="item__content__info__section__value" [innerHTML]="item.step === PermitStep.started ? t('awaitingConnection') : t('completionRequired')"></div>
                            </div>
                        </div>
                        <div>
                            <div *ngIf="isStandaloneFlammableAtex" class="item__content__info__section">
                                <div class="item__header__right__remove" (click)="remove($event)"></div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <div *ngIf="!isPlannedFlammableAtex && (item.publicStatus === PermitPublicStatus.ongoing || item.publicStatus === PermitPublicStatus.expiredNotSigned) && item.startDate && item.endDate" class="item__progress-bar">
                    <div class="item__progress-bar__status" [class.item__progress-bar__full]="getProgress(item.startDate, item.endDate) === 100" [style.width.%]="getProgress(item.startDate, item.endDate)"></div>
                </div>
            </div>
        </div>
    </a>
</ng-container>
